export const QUICK_LINKS = [
  { label: 'Birchwood', href: 'https://birchwood.meridianlink.com/custom/login.aspx' },
  { label: 'ValueLink', href: 'https://hometap.spurams.com/login.aspx?ReturnUrl=/' },
  { label: 'PACER', href: 'https://pacer.login.uscourts.gov/csologin/login.jsf' },
  { label: 'FEMA Map', href: 'https://msc.fema.gov/portal/home' },
];
